var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "product-delivery-item",
      class: { "product-delivery-item_disabled": _vm.disabled }
    },
    [
      _c("div", { staticClass: "product-delivery-item__content" }, [
        _c("div", { staticClass: "product-delivery-item__title" }, [
          _vm._v("\n      " + _vm._s(_vm.title) + "\n    ")
        ]),
        _c(
          "div",
          { staticClass: "product-delivery-item__description" },
          [
            _vm.disabled
              ? [_vm._v("\n        Недоступно\n      ")]
              : _vm._t("default", [
                  _vm.description
                    ? _c("span", {
                        domProps: { innerHTML: _vm._s(_vm.description) }
                      })
                    : _vm._e()
                ])
          ],
          2
        )
      ]),
      _vm.icon
        ? _c(
            "div",
            { staticClass: "product-delivery-item__icon" },
            [_c("f-sprite-icon", { attrs: { "icon-link": _vm.icon } })],
            1
          )
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }